"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CameraShutterOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CameraShutterOutlineSVG = function CameraShutterOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM12.19,15.74,13.89,13h3.64l1.62,2.92L17.23,19H14ZM25.76,9.05A11.86,11.86,0,0,1,28,16a12.33,12.33,0,0,1-.39,3h-8ZM24.4,7.45l-4,6.52L14.86,4.06A10.88,10.88,0,0,1,16,4,12,12,0,0,1,24.4,7.45Zm-11.61-3L16.42,11H5.11A12,12,0,0,1,12.79,4.45ZM4.39,13h7.15L5.79,22.27A11.88,11.88,0,0,1,4,16,12.33,12.33,0,0,1,4.39,13ZM7.08,24l3.9-6.3L16.68,28c-.23,0-.45,0-.68,0A11.9,11.9,0,0,1,7.08,24Zm11.71,3.67L15.1,21H26.89A12,12,0,0,1,18.79,27.66Z"
  }));
};
exports.CameraShutterOutlineSVG = CameraShutterOutlineSVG;
CameraShutterOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CameraShutterOutlineSVG);
exports.default = _default;